import React from 'react';
import { DownloadApplicationsPage } from './DownloadApplicationsPage';
import * as platformDetector from 'react-device-detect';

export class PlatformGate extends React.Component {
    render() {
        const isDocumentsPublicPage = /^\/documents\/association\/[a-fA-F0-9-]+/.test(window.location.pathname);

        if (isDocumentsPublicPage || !platformDetector.isMobile) return <>{this.props.children}</>;

        return <DownloadApplicationsPage isIOS={platformDetector.isIOS}>{this.props.children}</DownloadApplicationsPage>;
    }
}
